import React, {useState} from "react";
import {InputNumber} from "antd";
import {useProject} from "../../../providers/ClientProjectProvider";

const ProjectPercentMarkupForm = ({inline = false,...props}) => {

    const {
        project,
        isDisabled,
        isLoading,
        postUpdate
    } = useProject();

    const [model, setModel] = useState({percent_markup: ((parseFloat(project.percent_markup || 0)) * 100)});

    if (isLoading|| !project) {
        return null
    }
    return (
        <div className="flex flex-row gap-4 items-center">
            <div className={TB.mapClass("flex gap-1 ", {
                "flex-col items-start": !inline,
                "flex-row items-center ml-auto": inline
            })}>
                <p className="text-xs font-semibold">
                    Default Percent Markup (for all roles)
                </p>
                <div className="flex flex-row gap-2 items-center">
                    <div className="relative w-24">
                        <InputNumber
                            controls={false}
                            size="small"
                            min={0}
                            addonAfter="%"
                            precision={2}
                            value={model.percent_markup}
                            // formatter={value => Number(value).toFixed(2)}
                            onChange={(value) => setModel({percent_markup: parseFloat(value)})}/>
                    </div>
                    <button disabled={isDisabled} onClick={async () => {
                        postUpdate({percent_markup: parseFloat(Number(model.percent_markup / 100)).toFixed(3)})
                    }} className="btn btn-dark text-xxs py-0.5 px-1.5">
                        Update
                    </button>
                </div>
            </div>

        </div>
    )
}

export default ProjectPercentMarkupForm